import React, {FormEvent, ReactNode} from "react";
import '../../styles/common/form.scss';

export default function Form({children, additionalClassName, onSubmit}: {additionalClassName?: string, children: ReactNode, onSubmit?: (formEvent: FormEvent)=> void}) {
  return (
    <form onSubmit={onSubmit} className={`form ${additionalClassName ? additionalClassName : ''}`}>
      {children}
    </form>
  );
}